// src/components/A1cChart.js
import React, { useEffect, useState } from "react";
import { auth, db } from "../firebase";
import { collection, query, orderBy, onSnapshot } from "firebase/firestore";
import {
  LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer,
  ReferenceLine
} from "recharts";

export default function A1cChart() {
  const [readings, setReadings] = useState([]);
  const [range, setRange] = useState("30");

  useEffect(() => {
    const user = auth.currentUser;
    if (!user) return;

    const q = query(
      collection(db, "users", user.uid, "a1cReadings"),
      orderBy("createdAt", "asc")
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((doc) => {
        const item = doc.data();
        return {
          ...item,
         dateTime: item.createdAt?.toDate(),
        };
      });
      setReadings(data);
    });

    return () => unsubscribe();
  }, []);

  // Apply range filter
  const filtered = readings.filter((r) => {
    if (!r.dateTime) return false;

    if (range === "all") return true;

    const cutoff = new Date();
    cutoff.setDate(cutoff.getDate() - Number(range));
    return r.dateTime >= cutoff;
  }).map((r) => ({
    ...r,
    dateTime: r.dateTime.toLocaleDateString(),
  }));

  // CSV export
  const exportToCSV = () => {
    const rows = [["Date", "HbA1c (%)"]];
    readings.forEach((r) => {
      rows.push([r.dateTime.toLocaleString(), r.a1c]);
    });
    const csvContent = "data:text/csv;charset=utf-8," + rows.map(e => e.join(",")).join("\n");
    const link = document.createElement("a");
    link.href = encodeURI(csvContent);
    link.download = "a1c.csv";
    link.click();
  };

  return (
    <div style={{ width: "100%", height: 300, marginTop: "1rem" }}>
      <div style={{ marginBottom: "0.5rem" }}>
        <label>Range: </label>
        <select value={range} onChange={(e) => setRange(e.target.value)}>
          <option value="7">Last 7 days</option>
          <option value="30">Last 30 days</option>
          <option value="90">Last 90 days</option>
          <option value="365">Last 1 year</option>
          <option value="all">All</option>
        </select>
        <button onClick={exportToCSV} style={{ marginLeft: "1rem" }}>Export to CSV</button>
      </div>

      <ResponsiveContainer>
        <LineChart data={filtered}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="dateTime" />
          <YAxis domain={[4, 14]} />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="a1c" stroke="orange" />
          <ReferenceLine y={7} stroke="red" strokeDasharray="3 3" label="Target ≤7%" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
